import { defineStore } from "pinia"

interface IGameState {
  isDemo: boolean
  currency: string
  game: any | null
}

export const useGameStore = defineStore("game", {
  state: (): IGameState => ({
    isDemo: false,
    currency: "",
    game: null,
  }),

  actions: {
    saveGameState(state: IGameState) {
      this.isDemo = state.isDemo
      this.currency = state.currency
      this.game = state.game
    },

    clearGameState() {
      this.isDemo = false
      this.currency = ""
      this.game = null
    },
  },

  getters: {
    getGameState(): IGameState | null {
      if (!this.game)
        return null

      return {
        isDemo: this.isDemo,
        currency: this.currency,
        game: this.game,
      }
    },
  },
})
